import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainComponent from './components/MainComponent';
import NotFoundPage from './pages/NotFoundPage';
import GameLaunch from './pages/GameLaunch';
import withSplashScreen from "./components/withSplashScreen";
import HtmlLaunch from "./pages/HtmlLaunch"
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="round"
          element={
            <MainComponent />
          }
        />
        <Route
          path="launch"
          element={
            <GameLaunch />
          }
        />
        <Route
          path="htmllaunch"
          element={
            <HtmlLaunch />
          }
        />
        <Route
          path="*"
          element={
          <NotFoundPage />
        }
        />
        {/* Other routes go here */}
      </Routes>
    </BrowserRouter>
  );
};

export default withSplashScreen(App);
